export const formatLabel = (label, labelMapping) =>
  labelMapping[label] ||
  label
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('-');
